module.exports = __webpack_public_path__ + "media/frontend/components/library/images/logo-inverse-b125cc5a7373d2b62929911d06fe5767.png";